import _ from "lodash";
import Portfolio from "./portfolio";

/**
 * Backtest a portfolio long only with periodic rebalances
 * 
 * @author Giovanna Marinelli
 */
class Backtester {
  constructor() {
    // TODO: Pegar isso de outro lugar, sem ser hard coded (it sucks)
    this.ESSENCIAL = "Pandhora Essencial FIC FIM";
    this.LB = "Pandhora Long Bias FIC FIM";
    this.LB_INCEPTION = new Date(2019, 6, 25);
  }
  /**
   * Create a Portolio from a set of target positions and
   * its market data. This function will basically backtest 
   * an strategy which rebalance every 6 months with the given target position.
   * 
   * @param {Object} targetPositions an object with symbols as keys and position allocation as value.
   * @param {MarketData} marketdata a market data object that will be use to extract the returns.
   * @returns {Portfolio} a Portofolio object.
   */
  createPortfolio(targetPositions, marketdata) {
    

    // Collect market data
    const returns = marketdata.returnsMap;
    // Calculate backtest - i.e., the portfolio positions and the daily returns
    const dates = Object.keys(returns);
    let prevMonth = undefined;
    let prevDate = dates[0];

    const positions = {};
    const portfolioReturns = {};

    // Initialize positions and returns
    const firstPositions = _.cloneDeep(targetPositions);
    firstPositions[this.ESSENCIAL] += firstPositions[this.LB];
    firstPositions[this.LB] = 0.0;

    positions[prevDate] = firstPositions;
    portfolioReturns[prevDate] = 0.0;

    for (let i = 1; i < dates.length; i++) {
      const date = dates[i];
      const currentDate = new Date(date + "T00:00:00");
      const currentMonth = currentDate.getMonth();

      // Calculate portfolio return --------------------------------------------------------------------
      const prevPositions = positions[prevDate];
      const currentReturns = returns[date];
      const currentPortolioReturn = Object.keys(prevPositions).reduce(
        (sum, symbol) =>
          (sum += prevPositions[symbol] * currentReturns[symbol]),
        0.0
      );

      portfolioReturns[date] = currentPortolioReturn;

      // Calculate positions --------------------------------------------------------------------------
      let currentPositions = {};
      
      // If is rebalance date - Set position to target position
      if (
        (currentMonth === 5 && prevMonth === 4) ||
        (currentMonth === 11 && prevMonth === 10) || 
        (currentDate.getTime() === this.LB_INCEPTION.getTime())
      ) {
        currentPositions = _.cloneDeep(targetPositions);

        // Before LB inception, we allocate all fund allocation to Pandhora Essencial
        if (currentDate < this.LB_INCEPTION) {
          currentPositions[this.ESSENCIAL] += currentPositions[this.LB];
          currentPositions[this.LB] = 0.0;
        }
        // Else, variate the weights according asset returns
      } else {
        Object.keys(prevPositions).forEach(
          (symbol) =>
            (currentPositions[symbol] =
              (prevPositions[symbol] * (1 + currentReturns[symbol])) /
              (1+currentPortolioReturn))
        );
      }
      positions[date] = currentPositions;

      prevMonth = currentMonth;
      prevDate = date;
    }

    // Create portfolio and return
    const portfolio = new Portfolio();
    portfolio.setTargetPositions(targetPositions);
    portfolio.setPositions(positions);
    portfolio.setReturns(portfolioReturns);

    return portfolio;
  }
}

export default Backtester;
